import {permitApplicationFieldsUtil} from "permitapplication/utilities";

const permitUtil = permitApplicationFieldsUtil;
const createNotifications = permitUtil.createNotifications;

const getHolderStepFields = permit =>
    createNotifications([["Selecione o titular.", permit.holder]]);

const getDocStepRequiredFields = permit => {
    const basicFields = createNotifications([
        ["Selecione as guias da autorização.", !!permit.types?.length],
    ]);

    return basicFields;
};

const getAnalysisStepFields = permit => {
    const plotOwnershipDocField = createNotifications([
        ["Valide o título de terras.", !!permit.plot_ownership_doc_valid],
    ]);

    const personalIdDocField = createNotifications([
        ["Valide o BI/Cartão de residência.", !!permit.personal_id_doc_valid],
    ]);
    const taxIdDocField = createNotifications([
        ["Valide o Cartão Fiscal.", !!permit.tax_id_doc_valid],
    ]);
    const plotUseAuthorizationField = createNotifications([
        [
            "Valide a declaração de autorização de posse/aproveitamento de terra.",
            !!permit.plot_use_authorization_valid,
        ],
    ]);

    const requiredFields = [
        ...(permit.plot_ownership_doc ? plotOwnershipDocField : []),
        ...(permit.personal_id_doc ? personalIdDocField : []),
        ...(permit.tax_id_doc ? taxIdDocField : []),
        ...(permit.plot_use_authorization ? plotUseAuthorizationField : []),
    ];

    return requiredFields;
};

const getPlotStepFields = permit =>
    createNotifications([["Selecione a parcela", !!permit.plot]]);

const getVisitStepFields = permit =>
    createNotifications([
        ["Acrescente a data da vistoria", !!permit.inspection_date],
        ["Acrescente a equipa que realizou a vistoria", !!permit.inspection_team],
    ]);

const getTypesStepRequiredFields = permit => {
    const fieldsByType = {
        felling: [
            [
                "Acrescente as árvores do abate.",
                permitUtil.checkElements(permit?.tree_set, "felling"),
            ],
        ],
        cutting: [
            [
                "Acrescente as árvores da serragem.",
                permitUtil.checkElements(permit?.tree_set, "cutting"),
            ],
        ],
        clearing: [["Acrescente a área a desbravar.", !!permit.clearing_area]],
        transport: [
            [
                "Acrescente o destino dos materiais a transportar.",
                !!permit.transport_destination,
            ],
            ["Acrescente os materiais a transportar.", !!permit.material_set?.length],
        ],
    };

    const requiredFields = permit.types?.flatMap(type =>
        fieldsByType[type] ? createNotifications(fieldsByType[type]) : []
    );

    return requiredFields;
};

const getReportStepFields = permit =>
    createNotifications([["Indique o parecer técnico.", !!permit.technical_decision]]);

const getFeesStepRequiredFields = permit => {
    const fieldsByType = {
        felling: [
            [
                "Acrescente a taxa de abate das árvores.",
                permit.felling_price || permit.felling_price === 0,
            ],
        ],
        cutting: [
            [
                "Acrescente a taxa de serragem das árvores.",
                permit.cutting_price || permit.cutting_price === 0,
            ],
        ],
        clearing: [
            [
                "Acrescente a taxa de desbravamento.",
                permit.clearing_fee || permit.clearing_fee === 0,
            ],
        ],
        transport: [
            [
                "Acrescente a taxa de transporte dos materiais.",
                permitUtil.checkFeesInMaterials(permit?.material_set),
            ],
        ],
    };

    const requiredFields = permit.types?.flatMap(type =>
        fieldsByType[type] ? createNotifications(fieldsByType[type]) : []
    );

    return requiredFields || [];
};

const getInvoiceStepFields = permit =>
    createNotifications([
        ["Imprima a factura.", !!permit.printed_invoice],
        ["Indique si a factura foi enviada para o/a titular.", !!permit.invoice_sent],
    ]);

const getPaymentStepFields = permit =>
    createNotifications([["Imprima a autorização.", !!permit.printed_permit]]);

const getSignatureStepFields = permit =>
    createNotifications([
        [
            "Indique si a solicitação foi enviada para a Direcção.",
            !!permit.application_sent,
        ],
        ["Indique si a Direcção assinou a solicitação.", !!permit.application_signed],
    ]);

export const getRequiredFields = permit => ({
    holder_s: getHolderStepFields(permit),
    permit_s: getDocStepRequiredFields(permit),
    analysis_m: getAnalysisStepFields(permit),
    plot1_m: getPlotStepFields(permit),
    visit_m: getVisitStepFields(permit),
    permit_m: getTypesStepRequiredFields(permit),
    report_m: getReportStepFields(permit),
    payment_e: getFeesStepRequiredFields(permit),
    invoice_s: getInvoiceStepFields(permit),
    payment_s: getPaymentStepFields(permit),
    signature_s: getSignatureStepFields(permit),
});
